/** Street address input used by `tools.normaliseAddress` before hashing. */
export interface StreetAddress {
  /** Street number, for example `10`. */
  streetNumber: string;
  /** Street name without the street type. */
  streetName: string;
  /** Street type, normalised against `StreetTypes` when possible. */
  streetType: string;
  /** Suburb/locality. */
  suburb: string;
  /** State or territory. */
  state: string;
  /** Postcode. */
  postCode: string;
}

/** Standard street-type abbreviations used during address normalisation. */
export enum StreetTypes {
  alley = 'ally',
  arcade = 'arc',
  avenue = 'ave',
  boulevard = 'bvd',
  bypass = 'bypa',
  circuit = 'cct',
  close = 'cl',
  corner = 'crn',
  court = 'ct',
  crescent = 'cres',
  'cul-de-sac' = 'cds',
  drive = 'dr',
  esplanade = 'esp',
  green = 'grn',
  grove = 'gr',
  highway = 'hwy',
  junction = 'jnc',
  lane = 'lane',
  link = 'link',
  mews = 'mews',
  parade = 'pde',
  place = 'pl',
  ridge = 'rdge',
  road = 'rd',
  square = 'sq',
  street = 'st',
  terrace = 'tce',
  key = 'key',
}
